<template>
  <div
    class="video-popup"
  >
    <div class="video-popup__dim" />
    <div class="video-popup__body">
      <!-- <div class="video-popup__head">
        {{ item.title }}
      </div> -->
      <div class="video-popup__content">
        <div class="video-popup__content-inner">
          <div class="video-popup__player-container">
            <iframe
              :src="item.videoUrl"
              class="video-popup__player"
              width="720"
              height="480"
              allow="encrypted-media"
              allowfullscreen
              title="youtube"
            /> 
          </div>
        </div>
      </div>
    </div>
    <button
      class="video-popup__close-button"
      @click="$emit('click:close')"
    >
      <img
        src="/theme/rbFront/img/w/case-study/btn_popup_close_circle.png"
        class="video-popup__close-button-image"
        alt="Close"
      >
    </button>
  </div>
</template>

<script>
export default {
  name: 'VideoPopup',
  components: {
  },
  props: {
    item: {
      type: Object,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
$video-popup: '.video-popup';
#{$video-popup} {
  width: 100%;
  max-width: 1440px;
  position: fixed;
  box-sizing: border-box;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
  @media only screen and (max-width: 1080px){
    width: 100%;
    height: 100%;
  } 

  &__dim {
    position: fixed;
    background-color: #000;
    opacity: 0.4;
    width: 5000%;
    height: 5000%;
    left: -2500%;
    top: -2500%;
    z-index: 0;
  }
  &__body {
    position: relative;
    z-index: 1;
    background-color: #fff;
    @media only screen and (max-width: 1080px){
      background-color: #000;
      height: 100%;
    } 
  }
  &__content {
    padding: 0;
    @media only screen and (max-width: 1080px){
      padding: 0;
      height: 100%;
      margin-top: -54px;
    } 
  }
  &__content-inner {
    position: relative;
    margin: 0 auto;
    @media only screen and (max-width: 1080px){
      height: 100%;
    } 
  }
  &__player-container {
    padding-bottom: 50%;
    @media only screen and (max-width: 1080px){
      padding-bottom: 50%;
      position: absolute;
      left: 0;
      top: 50%;
      -ms-transform: translate(0, -50%);
      transform: translate(0, -50%);
      width: 100%;
    } 
  }
  &__player {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    margin: 0 !important;
    border: 0 !important;
  }
  &__close-button {
    position: fixed;
    top: 50%;
    right: 50%;
    transform: translate(calc(50vw - 55px), calc(-50vh + 30px));
    width: 49px;
    height: 49px;
    overflow:hidden;
    z-index:200;
    img {
      max-width: 100%;
      width: 100%;
    }
    @media only screen and (max-width: 1080px){
      top: 18px;
      right: 15px;
      width: 27px;
      height: 27px;
      transform: translate(0, 0);
    }
  }
}


</style>
